import React from "react";
import "../styles/Signature.css";

// Shared by task signatures and reusable account signature previews.
export default function SignatureImage({ src, alt = "Signature", className = "" }) {
  return (
    <img
      src={src}
      alt={alt}
      className={["signature-image", className].filter(Boolean).join(" ")}
      draggable={false}
      data-download-preserve-ratio
    />
  );
}

